import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ContentModule } from 'src/app/layout/components/content/content.module';
import { FooterModule } from 'src/app/layout/components/footer/footer.module';
import { NavbarModule } from 'src/app/layout/components/navbar/navbar.module';
import { ToolbarModule } from 'src/app/layout/components/toolbar/toolbar.module';
import { VerticalLayout1Component } from 'src/app/layout/vertical/layout-1/layout-1.component';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TaskReminderDetailsComponent } from '@pages/Task/task-reminder-details/task-reminder-details.component';
import { MaterialModule } from 'src/app/Shared/material.module';
import { AdminSidebar } from '../../ui/sidebar';
import { SchemeSwitcher } from '../../ui/scheme-switcher';
import { Notifications } from '../../ui/notifications';

// import { TaskReminderDetailsComponent } from 'src/app/main/pages/Task/task-reminder-details/task-reminder-details.component';

@NgModule({
  declarations: [VerticalLayout1Component, TaskReminderDetailsComponent],
  imports: [
    RouterModule,
    FormsModule,
    ContentModule,
    FooterModule,
    NavbarModule,
    ToolbarModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatMenuModule,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MaterialModule,
    AdminSidebar,
    SchemeSwitcher,
    Notifications,
  ],
  exports: [VerticalLayout1Component],
})
export class VerticalLayout1Module {}
